/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/ship
 */
import { default as DefaultIcon } from '~icons/lucide/ship';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const ShipIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
